import Service from "../service";
import AuthService from "../AuthService";

const SpecGroup = {
  getMainGroup(page) {
    return AuthService.get('/api/med-group?page='+page);
  },
  // getPaginateSpecGroup(page) {
  //   return AuthService.get('/api/get-paginate-spec-group?page='+page);
  // },
  getSearchMainGroup() {
    return AuthService.get('/api/get-main-group');
  },
  getSubGroup(id) {
    return AuthService.get(`/api/get-sub-group/${id}`);
  },
  getSearchGroup(data) {
    return AuthService.get(`/api/get-med-group?page=`+data.page+'&id='+data.id)
  }
};

export default SpecGroup;
